import React from 'react';
import { Button, Modal, Spinner} from 'react-bootstrap';

const ConfirmacionModal = ({ show, onHide, onConfirm, title, message, confirmButtonText, cancelButtonText, loading = false }) => {
    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Body>
                <p><strong>{title}</strong></p>
                <p className="text-muted">{message}</p>
                <div className="d-flex justify-content-end mt-3">
                    <Button 
                        variant="outline-secondary" 
                        onClick={onHide} 
                        className="me-2"
                        disabled={loading}
                    >
                        {cancelButtonText || 'Cancelar'}
                    </Button>
                    <Button 
                        variant="danger" 
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? (
                            <>
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                                Eliminando...
                            </>
                        ) : (
                            confirmButtonText || 'Eliminar'
                        )}
                    </Button>
                </div> 
            </Modal.Body>

        </Modal>
    );
}

export default ConfirmacionModal;